import { IGif } from "services/types";

export const filterGifsList = (prevGifs: IGif[], newGifs: IGif[] | undefined) => {
  // We extract newGifs from API responses which can be broken,
  // handle this here instead of multiple outside sources.
  if (!newGifs) {
    return prevGifs;
  }

  const previousIds = prevGifs.map(gif => gif.id);

  return [
    ...prevGifs,
    ...newGifs.filter(gif => previousIds.indexOf(gif.id) === -1)
  ];
};
